module.exports = __webpack_public_path__ + "img/CZ44848943.b047314f.svg";